import { Link } from 'react-router';
import { Table, Button, BPanel, Col, FormControl, Pager, PageItem, Checkbox, Progress } from '@sketchpixy/rubix';
import React from 'react';
import ReactDOM from 'react-dom';
import { Tracker } from 'meteor/tracker';
import { Meteor } from 'meteor/meteor';
import { debounce } from 'lodash';

import { Reservations } from '../../collections/reservations/reservations';
import { FlightsType } from '../../collections/flights-type/flights-type';

import ReservationComponent from './components/component-reservations-list';
import { Reactive } from '../common/Reactive.mixin.js';

@Reactive({
	subscriptions: [{name: 'reservations', paginate: true}, "users", 'flights-type'],
	partners: Meteor.users.find({roles:{$in:['partner']}})
})
export default class ReservationsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reservations: [],
			flightsType: []
		};

		props.ready.then(() => {
			Tracker.autorun(() => {
				this.setState({
					'reservations' : Reservations.find({}, {sort: {id: -1}}).fetch(),
					'flightsType' : FlightsType.find({}).fetch()
				});
			});
		});
	}

	renderSelectOptions(data, labelKey, notFoundText, needSelectedFlight = true) {
    if(!data || data.length == 0) {
      return (
        <option>{ notFoundText }</option>
      );
    }

    return data.map((item) => (
      <option value={item._id}>{ _.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey] }</option>
    ));
  }

	renderSelectFlight(data, labelKey, notFoundText, needSelectedFlight = true) {
    if(!data || data.length == 0) {
      return (
        <option>{ notFoundText }</option>
      );
    }

    return data.map((item) => (
      <option value={item.title}>{ _.isFunction(item[labelKey]) ? item[labelKey]() : item[labelKey] }</option>
    ));
  }

	reset() {
		this.props.subscriptions['reservations'].clear();

		this.setState({
			'reservations' : Reservations.find({}, {sort: {id: -1}}).fetch()
		});
	}

	searchByID() {

		if(ReactDOM.findDOMNode(this.refs.searchByID).value.trim() == '') {
			this.props.subscriptions['reservations'].clear();
			return ;
		}

		this.props.subscriptions['reservations'].search({id_internet: ReactDOM.findDOMNode(this.refs.searchByID).value.trim()});

		this.setState({
			id: ReactDOM.findDOMNode(this.refs.searchByID).value.trim()
		});
	}

	searchByBillet() {

		if(ReactDOM.findDOMNode(this.refs.searchByBillet).value.trim() == '') {
			this.props.subscriptions['reservations'].clear();
			return ;
		}

		this.props.subscriptions['reservations'].search({id_billet: {$regex: ".*" + ReactDOM.findDOMNode(this.refs.searchByBillet).value.trim() + ".*"}});

	}

	searchByName() {

		if(ReactDOM.findDOMNode(this.refs.searchByName).value.trim() == '') {
			this.props.subscriptions['reservations'].clear();
			return ;
		}

		this.props.subscriptions['reservations'].search({"searchName": {$regex: ".*" + ReactDOM.findDOMNode(this.refs.searchByName).value.trim() + ".*", '$options' : 'i'}});

	}

	filterBy() {

		let filter = ReactDOM.findDOMNode(this.refs.filter).value.trim();

		if(filter == 'all') {
			this.props.subscriptions['reservations'].clear();
			return '';
		}


		if(filter == 'partners') {
			this.props.subscriptions['reservations'].search({userId:{$ne: null}});
			return '';
		}

		if(filter == 'interne') {
			this.props.subscriptions['reservations'].search({userId: null});
			return '';
		}

		if(filter == 'interne-anjou') {
			this.props.subscriptions['reservations'].search({userId: null, place:'anjou'});
			return '';
		}

		if(filter == 'interne-nantes') {
			this.props.subscriptions['reservations'].search({userId: null, place: 'nantes'});
			return '';
		}

		this.props.subscriptions['reservations'].search({userId: filter});

	}

	filterByPrestation() {
		let prestation = ReactDOM.findDOMNode(this.refs.prestation).value.trim();

		if(!prestation) {
			reset();
			return;
		}


		console.log('prestation', prestation);
		this.props.subscriptions['reservations'].search({flightName: prestation});
	}

	showMode() {

		let mode = ReactDOM.findDOMNode(this.refs.mode).value.trim();

		console.log('mode', mode);

		if(mode == 'all') {
			this.filterBy();
			return ;
		}

		if(mode == 'waiting-scheduled') {
			this.props.subscriptions['reservations'].search({scheduledAt: null, state: {$lte : 5}});
		}

		if(mode == 'scheduled') {
			this.props.subscriptions['reservations'].search({scheduledAt: {$ne: null}, state: {$lte : 5}});
		}

		if(mode == 'done') {
			this.props.subscriptions['reservations'].search({state: 6});
		}

	}

	showPayments() {

		let payments = ReactDOM.findDOMNode(this.refs.payments).value.trim();

		if(payments == 'all') {
			this.filterBy();
			return ;
		}

		this.props.subscriptions['reservations'].search({solde: {$gt: "0"}});
	}


	renderReservations() {
		return this.state.reservations.map((reservation) => (
			<ReservationComponent key={reservation._id} reservation={reservation} />
		));
	}

	render() {

		return (
			<div>
				<BPanel header="Gérer vos réservations">
					<Col sm={6}>
						<Col sm={9}><FormControl type="text" ref="searchByID" placeholder="Rechercher par identifiant internet"/></Col><Col sm={3}><Button onClick={this.searchByID.bind(this)}>Recherche</Button></Col><br/><hr/>
						<Col sm={9}><FormControl type="text" ref="searchByName" placeholder="Recherche par nom/prénom"/></Col><Col sm={3}><Button onClick={this.searchByName.bind(this)}>Recherche</Button></Col><br/><hr/>
						<Col sm={9}><FormControl type="text" ref="searchByBillet" placeholder="Recherche par n° de billet" /></Col><Col sm={3}><Button onClick={this.searchByBillet.bind(this)}>Recherche</Button></Col>
						<hr/><br/>
						<Col sm={9}>
						Prestation :<br/>
						<FormControl componentClass="select" placeholder="select" ref="prestation" onChange={::this.filterByPrestation} >
								<option value="">Toutes les prestations</option>
								{_.includes(Meteor.user().roles, 'partner') &&
									this.renderSelectFlight(FlightsType.find({}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
								}
								{!_.includes(Meteor.user().roles, 'partner') &&
									this.renderSelectFlight(FlightsType.find({"partnerId": null}, { sort: { 'title': 1 } }).fetch(), 'title', '-', false)
								}
						</FormControl>
						</Col>
						<br/><hr/><Col sm={9}><Button onClick={this.reset.bind(this)}>Réinitialiser</Button></Col>

					</Col>
					<Col sm={4}>
						<center>
							{!_.includes(Meteor.user().roles, 'partner') &&
								<div>
									Filtrer par :<br/>
									<FormControl componentClass="select" placeholder="select" ref="filter" onChange={::this.filterBy} >
										<option value="all">Toutes les réservations</option>
										<option value="interne">Interne uniquement</option>
										<option value="interne-anjou">Interne uniquement (Anjou)</option>
										<option value="interne-nantes">Interne uniquement (Nantes)</option>
										<option value="partners">Partenaires uniquement</option>
										{this.props.partners.map((partner) => (
											<option value={partner._id}>{partner.displayName()}</option>
										))}
									</FormControl>
									<hr/>
									Affichage :<br/>
									<FormControl componentClass="select" placeholder="select" ref="mode" onChange={::this.showMode} >
										<option value="all">Toutes les réservations</option>
										<option value="waiting-scheduled">Non planifiées</option>
										<option value="scheduled">Planifiées et non volées</option>
										<option value="done">Volées</option>
									</FormControl>
									{!_.includes(Meteor.user().roles, 'partner') &&
										<div>
											<hr/>
											Paiements :<br/>
											<FormControl componentClass="select" placeholder="select" ref="payments" onChange={::this.showPayments} >
												<option value="all">Toutes les réservations</option>
												<option value="waiting">En attente paiement</option>
											</FormControl>
										</div>
									}
									<hr/>
								</div>
							}
							<Link to="reservations-add"><Button bsStyle="success">Créer une réservation</Button></Link>
							<br/><br/>
						</center>
					</Col>
				</BPanel>
				<BPanel header="Liste des réservations">
					{!this.state.reservations.length &&
						<Progress active value={100} />
					}

					{this.state.reservations.length > 0 &&
					<Table striped bordered condensed hover responsive className="text-center">
						<thead>
							<tr >
								<th className="text-center">Identifiant</th>
								<th className="text-center">Billet</th>
								<th className="text-center">Nom/Prénom</th>
								<th className="text-center">Partenaire</th>
								<th className="text-center">Status</th>
								<th className="text-center">Montant</th>
								<th className="text-center">Date</th>
								{!_.includes(Meteor.user().roles, 'partner') &&
									<th className="text-center">Facturé ?</th>
								}
								<th className="text-center">Billet à envoyer ?</th>
								<th className="text-center">Actions</th>
							</tr>
						</thead>
						<tbody>
							{this.renderReservations()}
						</tbody>
					</Table>
					}
						{this.props.isReady &&
							<Pager>
								<PageItem href="#" onClick={::this.props.subscriptions['reservations'].more}>Voir plus</PageItem>
							</Pager>
						}

				</BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/page-reservations-list.js
 **/